// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__1Ja0K","header":"PatientBlock_header__1vaTZ","label":"PatientBlock_label__29QBI","option":"PatientBlock_option__Zf_nS"};